module.exports = __webpack_public_path__ + "img/helpbanner.69150f64.png";